import { createContext } from 'react';

export const PinnedClasses = createContext();
export const CurrentFlow = createContext();
export const CourseSections = createContext();
export const CourseCode = createContext();

export const IsMobile = createContext();
export const MobileCourseOpen = createContext();
